import React, { useMemo } from 'react';
import { Checkbox, MenuDropdown } from '@peoplegrove/pg-components';
import { useConversationSnapshotFiltersContext } from '../context/ConversationSnapshotFiltersContext';

const FILTER_OPTIONS = [
  { key: 'includeProductionHubs', label: 'Include production hubs' },
  { key: 'includeSuperadmin', label: 'Include Superadmin' },
  { key: 'includeClientAdmin', label: 'Include Client admin' },
  { key: 'includeNonAdminUsers', label: 'Include non-admin users' },
];

const SnapshotFiltersDropdown = () => {
  const { pendingFilters, setSnapshotFilters } =
    useConversationSnapshotFiltersContext();

  const menuItems = useMemo(
    () =>
      FILTER_OPTIONS.map(({ key, label }) => ({
        key,
        preventCloseOnClick: true,
        label: (
          <Checkbox
            checked={Boolean(pendingFilters[key])}
            onChange={checked => setSnapshotFilters(key, checked)}
            style={{ margin: 0 }}
          >
            {label}
          </Checkbox>
        ),
      })),
    [pendingFilters, setSnapshotFilters]
  );

  return (
    <MenuDropdown
      items={menuItems}
      position="bottom"
      buttonProps={{
        size: 'small',
        icon: 'pg-filter-o',
        type: 'tertiary',
      }}
    >
      Filters
    </MenuDropdown>
  );
};

export default SnapshotFiltersDropdown;
